<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Editar tipo de máquina</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Atrás</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form ref="profile_form" @submit.prevent="handleSubmit">
              <base-input
                label="Nombre"
                prepend-icon="fas fa-desktop"
                v-model="tipo.nombre"
              />
              <validation-error :errors="apiValidationErrors.nombre" />
              <base-input
                label="Capacidad (kg)"
                type="number"
                prepend-icon="fas fa-weight-hanging"
                v-model="tipo.capacidad"
              />
              <validation-error :errors="apiValidationErrors.capacidad" />
              <base-input
                label="Elevación (mm)"
                type="number"
                prepend-icon="fas fa-text-height"
                v-model="tipo.elevacion"
              />
              <validation-error :errors="apiValidationErrors.elevacion" />
              <div class="form-group">
                <label class="form-control-label"> Imagen </label>
                <div v-if="image" class="profile-image card-img pb-4">
                  <img :src="`${image}`" class="profile-image argon-image" />
                </div>
                <div v-else class="profile-image">
                  <img
                    src="/img/placeholder.png"
                    class="argon-image"
                    width="212"
                  />
                </div>
                <div class="image-upload">
                  <base-button
                    v-if="image"
                    type="button"
                    class="btn btn-sm btn-danger"
                    @click="removeImage"
                  >
                    <span>
                      <i class="fa fa-times" />
                      Eliminar
                    </span>
                  </base-button>
                  <base-button type="button" class="btn btn-sm btn-primary">
                    <label v-if="!image" for="imageInput" class="mb-0"
                      >Seleccionar imagen</label
                    >
                    <label v-else for="imageInput" class="mb-0">Cambiar</label>
                    <input
                      id="imageInput"
                      ref="imageInput"
                      accept="image/*"
                      type="file"
                      style="display: none"
                      @change="onSelectFile"
                    />
                  </base-button>
                </div>
              </div>
              <validation-error :errors="apiValidationErrors.attachment" />

              <div class="my-4">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Actualizar tipo de máquina
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import { omit } from "lodash";

export default {
  layout: "DashboardLayout",

  mixins: [formMixin],

  components: {
    ValidationError,
  },

  data() {
    return {
      file: null,
      image: null,
      tipo: {
        type: "tipos",
        nombre: null,
        capacidad: null,
        elevacion: null,
        imagen: null,
      },
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("tipos/get", id);

        this.tipo = this.$store.getters["tipos/tipo"];

        if (this.tipo.imagen.data) {
          this.image = this.tipo.imagen.data[0].attributes.url;
        }

        console.log(this.tipo);
        console.log(this.image);
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        console.log(error);
        this.setApiValidation(error.response.data.errors);
      }
    },
    removeImage() {
      this.image = null;
    },
    async handleSubmit() {
      console.log("ENTRA");
      if (this.file) {
        console.log(this.file);
        await this.$store.dispatch("items/upload", {
          item: this.tipo,
          image: this.file,
        });

        this.tipo.imagen = await this.$store.getters["items/url"];
      }
      console.log(this.tipo);

      try {
        await this.$store.dispatch("tipos/update", this.tipo);
        this.$notify({
          type: "success",
          message: "Tipo updated successfully.",
        });
        this.goBack();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },

    async onSelectFile(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };

      reader.readAsDataURL(file);
    },

    goBack() {
      this.$router.push({ name: "List Tipos de máquina" });
    },
  },
};
</script>
